import { render, staticRenderFns } from "./cq-deck-presets.vue?vue&type=template&id=13c46f18&scoped=true&"
import script from "./cq-deck-presets.vue?vue&type=script&lang=js&"
export * from "./cq-deck-presets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c46f18",
  null
  
)

export default component.exports